// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CaFc","col":"styles_col__36qOu"};